import { render, staticRenderFns } from "./ScreeningsAvailableListPage.vue?vue&type=template&id=1a07341e&scoped=true&"
import script from "./ScreeningsAvailableListPage.vue?vue&type=script&lang=js&"
export * from "./ScreeningsAvailableListPage.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningsAvailableListPage.vue?vue&type=style&index=0&id=1a07341e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a07341e",
  null
  
)

export default component.exports